const getPercentageAmount = (total, percentage) => total * (percentage / 100)

export default getPercentageAmount



// WEBPACK FOOTER //
// ./src/helpers/get-percentage-amount.js